<template>
  <div class="page_content">
    <div class="row page-heading mx-0">
      <div class="col-8 input module_heading" role="heading" aria-level="1">
        <span class="module_icon icon-plug">
          <i class="fa fa-plug fa-rotate-90" aria-hidden="true"></i>
        </span>
        <span class="module_type_name" style="padding: 6px 5px 0 3px !important;">Connector Management</span>
      </div>
      <div class="col-4 submit btn-container text-right">
        <button type="button" class="btn btn-primary" @click.prevent="create" aria-label="create" :disabled="permission.systemPermission.readOnly">create</button>
        <button type="button" class="btn btn-primary" :disabled="(selected.length === 0)" @click.prevent="showDeleteConfirm" aria-label="delete">delete</button>
      </div>
    </div>

    <div class="course-management-section">
      <div class="page_subheading">
        <div class="course-list-left">
          <span class="selected-count ace_sec_txt">selected: {{ selected.length }} of {{ totalElements }}</span>
        </div>
        <div class="toolbar-right ui-list-toolbar">
          <select v-model="pageSize" @change="resetPage" aria-label="page size" class="page_size">
            <option v-for="option in sizeOptions" v-bind:value="option">
              {{ option }}
            </option>
          </select>
          <div class="btn_container pagination_sty3">
            <button type="button" :disabled="this.firstPage" v-on:click="prev" class="btn btn_trans" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
            <span class="page_count" aria-hidden="true">{{ page + 1 }}</span>
            <button type="button" :disabled="this.lastPage" v-on:click="next" class="btn btn_trans" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
          </div>
        </div>
      </div>

      <div class="course-management-table-container">
        <table v-if="isConnectorsLoaded" class="table b-table table-bordered border">
          <thead class="thead-light text-center">
            <tr>
              <th class="first-column">
                <label class="form-checkbox">
                  <input type="checkbox" v-model="selectAll" @click="select" :disabled="(connectors.length === 0) || permission.systemPermission.readOnly" aria-label="select all connectors">
                  <i class="form-icon"></i>
                </label>
              </th>
              <th class="second-column">Connector Name</th>
              <th class="third-column">Connector Type</th>
              <th class="fourth-column">Action</th>
            </tr>
          </thead>
          <tbody v-if="connectors.length > 0">
            <tr v-for="connector in connectors">
              <td class="first-column text-center">
                <label class="form-checkbox">
                  <input type="checkbox" :value="connector.uuid" v-model="selected" :state="deselect" :disabled="(connectors.length === 0) || permission.systemPermission.readOnly" aria-label="select connector">
                  <i class="form-icon"></i>
                </label>
              </td>
              <td class="second-column">{{ formattedName(connector) }}</td>
              <td class="third-column">{{ connector.lmstype }}</td>
              <td class="fourth-column">
                <template v-if="permission.systemPermission.readOnly">
                  <span class="action-link icon-pencil" @click="edit(connector)" aria-label="edit" tabindex="0" style="pointer-events: none; color: #ccc;"></span>
                </template>
                <template v-else>
                  <span class="action-link icon-pencil" @click="edit(connector)" aria-label="edit" tabindex="0"></span>
                </template>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
            	<td colspan="5" class="no-result" style="text-align: center;">No Results Found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div>
      <b-modal class="delete-folder-popup" ref="deleteConfirmModal" no-close-on-backdrop no-close-on-esc centered>
        <div style="text-align: center;">
            <h6>Are you sure you want delete these ({{ selected.length }}) Connectors?</h6>
        </div>
				<div slot="modal-header" class="header-section">
					<div class="popup-heading">Please Confirm!</div>
				  <button class="btn_close" aria-label="close" @click="cancelDelete">
            <span class="ic-close"></span>
          </button>
				</div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="deleteSelected" class="btn button-primary next float-right mr-2" aria-label="ok"> yes </b-button>
          <b-button @click="cancelDelete" class="btn button-primary next float-right mr-2" aria-label="cancel"> no </b-button>
        </div>
      </b-modal>
    </div>

    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import '../../../assets/module/css/course/courseList.min.css'
  export default {
    name: 'connector-list',
    data () {
      return {
        connectors: [],
        pageSize: 10,
        sizeOptions: [ 10, 50, 100 ],
        firstPage: true,
        lastPage: false,
        page: 0,
        totalElements: 0,
        selected: [],
        selectAll: false,
        isConnectorsLoaded: false
      }
    },

    mounted () {
      this.loadPermission().then(res => {
        this.$refs.loadingModal.show()
        setTimeout(() => {
          this.loadConnectorList()
        }, 500)
      })
    },

    methods: {
      ...mapActions([
        'loadAllConnectors',
        'deleteConnectors',
        'loadPermission'
      ]),

      loadConnectorList () {
        this.loadAllConnectors({page: this.page, count: this.pageSize}).then(result => {
          this.connectors = result.content
          this.firstPage = result.first
          this.lastPage = result.last
          this.page = result.number
          this.totalElements = result.totalElements
          this.$refs.loadingModal.hide()
          this.isConnectorsLoaded = true
          if (this.selectAll) {
            this.selected = []
            this.selectAll = false
          }
        })
      },

      select () {
        this.selected = []
        if (!this.selectAll) {
          for (var i in this.connectors) {
            this.selected.push(this.connectors[i].uuid)
          }
        }
      },

      create () {
        return this.$router.push({name: 'connectorCreate'})
      },

      edit (connector) {
        return this.$router.push({name: 'connectorEdit', params: {uuid: connector.uuid}})
      },

      showDeleteConfirm () {
        if (this.selected.length > 0) {
          this.$refs.deleteConfirmModal.show()
        }
      },

      deleteSelected () {
        this.$refs.deleteConfirmModal.hide()
        this.$refs.loadingModal.show()
        this.deleteConnectors(this.selected).then(res => {
          if (res) {
            if (res.succeeded > 0) {
              let message = '' + res.succeeded + ' Connector(s) deleted successfully.'
              setTimeout(() => {
                this.$notify({
                  group: 'notify',
                  type: 'success',
                  title: '',
                  text: message
                })
              }, 0)
            }
            if (res.unauthorized > 0) {
              let message = '' + res.unauthorized + ' Connector(s) not deleted due to lack of permission.'
              setTimeout(() => {
                this.$notify({
                  group: 'notify',
                  type: 'warn',
                  title: '',
                  text: message
                })
              }, 500)
            }
          } else {
            this.$notify({
              group: 'notify',
              type: 'error',
              title: '',
              text: 'Connector deletion failed due to network issue.'
            })
          }
          setTimeout(() => {
            this.loadConnectorList()
          }, 1000)
        })
        this.selected = []
        this.selectAll = false
      },

      cancelDelete () {
        this.$refs.deleteConfirmModal.hide()
        this.selected = []
        this.selectAll = false
      },

      resetPage () {
        this.page = 0
        this.loadConnectorList()
      },

      prev () {
        this.page -= 1
        this.loadConnectorList()
      },

      next () {
        this.page += 1
        this.loadConnectorList()
      },

      formattedName (connector) {
        return connector.connectorName.split(':')[0]
      }
    },
    computed: {
      ...mapState({
        'permission': state => state.user.permission
      }),

      deselect () {
        if (this.selected.length === this.connectors.length) {
          this.selectAll = true
        } else {
          this.selectAll = false
        }
      }
    }
  }
</script>

<style scoped>
  .icon-plug {
    color: #157099;
    font-size: 32px !important;
  }

  .icon-pencil {
    cursor: pointer;
    font-size: 18px;
    margin-right: -5px;
    margin-top: 0;
    color: #157099;
  }
</style>



// WEBPACK FOOTER //
// src/app/connector/components/ConnectorList.vue